<template>
  <div id="activate">
    <ObjectFit
      :src="require('../../assets/backgroundImage.png')"      
      title="background image"
      alt="background image"
    />

    <Modal small="true">      
      <template v-slot:title>
        <h1>Set password</h1>
      </template>

      <template v-slot:content>
        <!-- <p>
          This link is not available
        </p> -->

        <form>
          <Input
            class="password"
            placeholder="Password"
            type="password"
            v-model="reset.password"
            v-on:handleKeyupEnter="handleChangePassword"
            v-on:handleKeyup="checkCorrect(reset.password)"
          />

          <Input
            class="repeatPassword"
            placeholder="Repeat Password"
            type="password"
            v-model="reset.repeatPassword"
            v-on:handleKeyupEnter="handleChangePassword"
            v-on:handleKeyup="checkrepeatPasswordCorrect"
          />
          
          <p
            class="minimal-password"
            v-if="minimal !== false"
          >
            Minimal of 8 characters, 1 capitalletter, 1 lowercase and 1 number
          </p>

          <ButtonForm
            v-if="correct === true && repeatPasswordCorrect === true"
            title="Set password"
            v-on:handleClick="handleChangePassword"
          />
        </form>
      </template>
    </Modal>

    <img
      class="login--logo"
      src="../../assets/logo.png"
      title=""
      alt=""
    >
  </div>  
</template>

<script>
  import { API } from '../../services/api.ts';
  import ObjectFit from '../../components/images/objectFit.vue'
  import Modal from '../../components/modal/modal.vue'

  import Input from '../../components/form/input.vue'
  import ButtonForm from '../../components/form/button.vue'
  import Button from '../../components/buttons/button.vue'
  import router from '@/router';

  export default {
    name: 'ActivateAccount',
    components: {
      ObjectFit,
      Modal,
      Input,
      ButtonForm,
      Button
    },
    data() {
      return {
        correct: false,
        repeatPasswordCorrect: false,
        minimal: null,
        reset: {
          password: '',
          repeatPassword: ''
        }
      }
    },
    methods: {
      checkCorrect: function(data) {
        let password = this.$el.querySelector('.password input');

        if (
          data.match(/[a-z]/) 
          && data.match(/[A-Z]/)
          && data.match(/[0-9]/)
          && data.length > 7
        ) {
          this.correct = true
          password.style.border = '1px solid var(--blue-medium)';
        } else {
          this.correct = false
          password.style.border = '1px solid red';
        }

        this.checkrepeatPasswordCorrect();
      },
      checkrepeatPasswordCorrect: function() {
        let repeatPassword = this.$el.querySelector('.repeatPassword input');

        if (this.reset.password !== this.reset.repeatPassword) {
          repeatPassword.style.border = '1px solid red';
          this.repeatPasswordCorrect = false;
          this.minimal = null;
        } else {
          repeatPassword.style.border = '1px solid var(--blue-medium)';
          this.repeatPasswordCorrect = true;
          this.minimal = false;
        }
      },
      handleChangePassword: function() {
        let password = this.$el.querySelector('.password input');
        let repeatPassword = this.$el.querySelector('.repeatPassword input');

        if (this.reset.password === '') {
          password.style.border = '1px solid red';
          repeatPassword.style.border = '1px solid red';
          
          return
        }

        if (this.reset.password === this.reset.repeatPassword) {
          password.style.border = '1px solid var(--blue-medium)';
          repeatPassword.style.border = '1px solid var(--blue-medium)';

          if (this.reset.password === this.reset.repeatPassword) {
            API.patch(
              `index.cfm?act=accounts.updatepassword`,
              {
                uuid: `${this.$route.params.id}`,
                password: this.reset.password
              }
            ).then(
              response => {
                console.log(response);
                window.location.href = '/';
              }
            )
          }
        } else {
          password.style.border = '1px solid red';
          repeatPassword.style.border = '1px solid red';
        }
      },
    }
  }
</script>

<style lang="scss">
  #activate {
    height: 100vh;
    overflow: hidden;

    .button-login {
      display: inline-block;
    }

    .login--logo {
      width: 87px;      
      margin: auto;
      position: absolute;
      right: 0;
      left: 0;
      bottom: 30px;
      z-index: 10;
    }
  }
</style>
